var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_14078_48799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.357 0.337162L28.8205 3.14329C29.1532 3.41255 29.585 3.52828 30.0078 3.46096L34.409 2.7651C35.1145 2.65316 35.8019 3.05101 36.0575 3.71813L37.6532 7.87815C37.8067 8.27827 38.1228 8.59443 38.5228 8.74797L42.682 10.3439C43.349 10.5996 43.7468 11.2871 43.6349 11.9928L42.9392 16.3948C42.8719 16.8177 42.9876 17.2495 43.2568 17.5823L46.0624 21.0465C46.5131 21.6017 46.5131 22.3974 46.0624 22.9526L43.2568 26.4167C42.9876 26.7495 42.8719 27.1814 42.9392 27.6042L43.6349 32.0063C43.7468 32.712 43.349 33.3995 42.682 33.6552L38.5228 35.2511C38.1228 35.4046 37.8067 35.7208 37.6532 36.1209L36.0575 40.2809C35.8019 40.9481 35.1145 41.3459 34.409 41.234L30.0078 40.5381C29.585 40.4708 29.1532 40.5865 28.8205 40.8558L25.357 43.6619C24.8019 44.1127 24.0064 44.1127 23.4513 43.6619L19.9878 40.8558C19.6551 40.5865 19.2233 40.4708 18.8006 40.5381L14.3994 41.234C13.6938 41.3459 13.0064 40.9481 12.7508 40.2809L11.1552 36.1209C11.0017 35.7208 10.6856 35.4046 10.2855 35.2511L6.12629 33.6552C5.45931 33.3995 5.06153 32.712 5.17346 32.0063L5.86918 27.6042C5.93648 27.1814 5.82078 26.7495 5.55157 26.4167L2.73842 22.9601C2.28771 22.4049 2.28771 21.6092 2.73842 21.0541L5.544 17.5899C5.81322 17.2571 5.92892 16.8252 5.86162 16.4024L5.16589 12.0004C5.05397 11.2947 5.45175 10.6071 6.11873 10.3515L10.278 8.75553C10.678 8.60199 10.9941 8.28583 11.1476 7.88571L12.7432 3.72569C12.9988 3.05857 13.6862 2.66072 14.3918 2.77267L18.793 3.46852C19.2157 3.53584 19.6475 3.42012 19.9803 3.15085L23.4438 0.344726C23.9988 -0.11212 24.7982 -0.115145 25.357 0.337162Z",
    fill: "#DE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14078_48799",
    x: 0.400391,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14078_48799"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14078_48799",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.cb8f092b3bd5bf3391d815073fd3e54f.svg";
export { ForwardRef as ReactComponent };